import React from 'react';
import { connect } from 'react-redux';
import { isEmpty, cloneDeep, findIndex } from 'lodash';

import MoreToExploreList from '../molecules/moreToExploreCollection/MoreToExploreList';
import MoreToExploreDetails from '../molecules/moreToExploreCollection/MoreToExploreDetails';
import MoreToExplorePlaces from '../molecules/moreToExploreCollection/MoreToExplorePlaces';

import {
  getMoreToExploreCollection,
  getMoreToExplore,
  postMoreToExplore,
  patchMoreToExplore,
} from '../common/actions/moreToExploreCollection';
import { getPlaces } from '../common/actions/places';
import { getCustomisedTypes, getFilterStr } from '../common/global';

import ACSaveBar from '../atoms/ACSaveBar';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import styles from './MoreToExploreCollectionPage.module.scss';

class MoreToExploreCollectionPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      moreToExploreCollection: [],
      moreToExplore: {},
      places: [],
      // Search
      searchText: '',

      // updateData is used to store update data field
      updateData: {},
      // Confirmation dialog related states
      openDialog: false,
      selection: {},

      // Alert dialog related states
      openAlertDialog: false,
      errors: [],

      // SetPlaces Section Variables here
      selectedType: {},
      selectedPlaces: [],
      mtePlaces: [], // All the places available for the more to explore element.
    };
  }

  componentDidMount() {
    const {
      gotoId,
      getMoreToExploreFunc,
      getMoreToExploreCollectionFunc,
      getPlacesFunc,
    } = this.props;

    getMoreToExploreCollectionFunc();
    getPlacesFunc();
    if (gotoId && !isEmpty(gotoId)) {
      getMoreToExploreFunc(gotoId);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      moreToExploreCollection = [],
      moreToExplore = {},
      places = [],
      filter = {},
      isRefreshRequired = false,
      getMoreToExploreCollectionFunc,
      getMoreToExploreFunc,
    } = this.props;

    if (prevProps.moreToExploreCollection !== moreToExploreCollection) {
      this.setState({ moreToExploreCollection });
    }

    if (prevProps.moreToExplore !== moreToExplore) {
      this.setState({ moreToExplore });
    }

    if (prevProps.places !== places) {
      this.setState({ places });
    }

    if (
      prevProps.filter !== filter ||
      (prevProps.isRefreshRequired !== isRefreshRequired && isRefreshRequired === true)
    ) {
      let { keyword = '' } = this.state;
      let filterStr = getFilterStr(filter);
      if (!isEmpty(keyword)) filterStr += '&keyword=' + keyword;
      getMoreToExploreCollectionFunc(filterStr);
      if (!isEmpty(moreToExplore)) getMoreToExploreFunc(moreToExplore.id || '');
    }
  }

  onUpdateMoreToExplore = (key, value) => {
    // Internal Update
    const { moreToExploreCollection = [], moreToExplore = {}, updateData = {} } = cloneDeep(
      this.state
    );

    moreToExplore[key] = value;
    updateData[key] = value;
    moreToExploreCollection.forEach((newMoreToExplore) => {
      if (newMoreToExplore.id === moreToExplore.id) {
        newMoreToExplore[key] = value;
      }
    });

    this.setState({ moreToExploreCollection, moreToExplore, updateData });
  };

  onUpdateMoreToExploreAddress = (whereValue) => {
    // Internal Update
    let { moreToExploreCollection, moreToExplore, updateData } = cloneDeep(this.state);

    moreToExplore.where = whereValue;

    if (!updateData.where) updateData.where = {};
    updateData.where.address = whereValue.address;

    moreToExploreCollection.forEach((mte) => {
      if (mte.id === moreToExplore.id) {
        mte = cloneDeep(moreToExplore);
      }
    });

    this.setState({
      moreToExploreCollection,
      moreToExplore,
      updateData,
    });
  };

  onCreateMoreToExplore = () => {
    let { moreToExplore, moreToExploreCollection } = cloneDeep(this.state);
    // Internal update
    let updateData = { status: 'active' };

    // This indicates there is already an unsaved moreToExplore
    let found = moreToExploreCollection.find((l) => {
      return !l.id || l.id === '';
    });
    if (found) return;

    moreToExplore = cloneDeep(updateData);

    moreToExploreCollection.push(moreToExplore);

    this.setState({
      moreToExploreCollection,
      moreToExplore,
      updateData,
    });
    this.setUnsavedDataFlag(updateData);
  };

  setUnsavedDataFlag(unsavedData) {
    if (!isEmpty(unsavedData)) this.props.setUnsavedDataFlagFunc(true);
  }

  onChangeSearchText = (event) => {
    const { filter = {}, getMoreToExploreCollectionFunc } = this.props;
    const searchText = event.target.value;
    let filterStr = getFilterStr(filter);
    filterStr += '&keyword=' + searchText;

    getMoreToExploreCollectionFunc(filterStr);

    this.setState({
      searchText,
    });
  };

  onSelectMoreToExplore = (moreToExplore) => {
    if (!isEmpty(this.state.updateData)) {
      this.setState({
        openDialog: true,
        selection: moreToExplore,
      });
      return;
    }

    this.props.getMoreToExploreFunc(moreToExplore.id);
    // Internal update
    this.setState({
      // Reset updateData
      updateData: {},
    });
  };

  onAddSelectedPlace = (place) => {
    let { selectedPlaces } = cloneDeep(this.state);

    if (findIndex(selectedPlaces, { id: place.value }) < 0) {
      const { object = {} } = cloneDeep(place);
      selectedPlaces.push(object);
    }

    this.setState({ selectedPlaces });
  };

  onSaveMtePlaces = () => {
    const { selectedPlaces = [], moreToExplore = {}, selectedType = '' } = cloneDeep(this.state);
    const { places = [] } = cloneDeep(moreToExplore);

    let removeIndex = places.findIndex((p) => {
      return p.type === selectedType.value;
    });

    while (removeIndex > -1) {
      places.splice(removeIndex, 1);
      removeIndex = places.findIndex((p) => {
        return p.type === selectedType.value;
      });
    }
    const joinPlaces = places.concat(selectedPlaces);

    moreToExplore.places = joinPlaces;
    this.props.patchMoreToExploreFunc(moreToExplore);
  };

  onDeletePlace = (place) => {
    let { selectedPlaces } = cloneDeep(this.state);

    const filteredPlaces = selectedPlaces.filter((p) => {
      return p.id !== place.id;
    });

    this.setState({ selectedPlaces: filteredPlaces });
  };

  onDeletePlaces = (type) => {
    const { moreToExplore = {} } = cloneDeep(this.state);
    const { places = [] } = cloneDeep(moreToExplore);

    const filteredPlaces = places.filter((p) => {
      return p.type !== type.value;
    });
    moreToExplore.places = filteredPlaces;
    this.props.patchMoreToExploreFunc(moreToExplore);
  };

  onClickDialogYes = () => {
    this.resetUnSavedDataFlag();
    this.setState(
      {
        openDialog: false,
        // Reset updateData
        updateData: {},
      },
      // Callback function has been used to make the selection,
      // if the user decides to leave the changes.
      () => {
        this.onSelectMoreToExplore(this.state.selection);
      }
    );
  };

  onClickDialogNo = () => {
    this.setState({
      openDialog: false,
    });
  };

  onClickAlertDialogClose = () => {
    this.setState({
      openAlertDialog: false,
    });
  };

  resetUnSavedDataFlag() {
    this.props.setUnsavedDataFlagFunc(false);
  }

  onSwapPlaces = (from, to) => {
    const { moreToExplore } = cloneDeep(this.state);
    const { places } = cloneDeep(moreToExplore);

    const fromType = places[from].type;
    const toType = places[to].type;

    // Only swap within same type.
    if (fromType !== toType) return null;
    let temp = places[from];
    temp.type = toType;
    places[from] = places[to];
    places[from].type = fromType;
    places[to] = temp;

    moreToExplore.places = cloneDeep(places);
    this.props.patchMoreToExploreFunc(moreToExplore);
  };

  onSelectType = (type, places) => {
    this.setState({ selectedPlaces: places, selectedType: type });

    this.updateTypeAndPlacesState(type);
  };

  onChangeType = (type) => {
    const { object } = cloneDeep(type);
    this.updateTypeAndPlacesState(object);
  };

  updateTypeAndPlacesState(type) {
    const { moreToExplore = {} } = cloneDeep(this.state);
    this.setState({ selectedType: type });

    let filterStr = `&types=${type.value}`;

    this.props.getPlacesFunc(filterStr);

    // Needs to change the selected places to reflect on change of the type
    if (!isEmpty(moreToExplore)) {
      const { places = [] } = moreToExplore;

      const filteredPlaces = places.filter((p) => {
        return p.type === type.value;
      });
      this.setState({ selectedPlaces: filteredPlaces });
    }
  }

  onChangePlace = (place = {}) => {
    this.onAddSelectedPlace(place);
  };

  onInputChangePlace = (type, query) => {
    const { getPlacesFunc } = this.props;
    let filterStr = `&types=${type.value}&keyword=${query}`;
    getPlacesFunc(filterStr);
  };

  onSaveMoreToExplore = () => {
    // External update
    let ud = cloneDeep(this.state.updateData);

    if (isEmpty(ud) || !this.state.moreToExplore) return;
    if (this.state.moreToExplore.id) ud.id = this.state.moreToExplore.id;

    if (ud.id) {
      this.props.patchMoreToExploreFunc(ud);
    } else {
      if (!ud.name) {
        this.setState({
          openAlertDialog: true,
          errors: ['Please enter a name to save.'],
        });
        return;
      }
      this.props.postMoreToExploreFunc(ud);
    }

    this.setState({
      updateData: {},
    });
    this.resetUnSavedDataFlag();
  };

  clearSetPlaces = () => {
    this.setState({ selectedType: {}, selectedPlaces: [] });
  };

  renderMoreToExploreList(moreToExploreCollection, moreToExplore) {
    return (
      <div className={styles.left} key="moreToExploreList">
        <MoreToExploreList
          searchText={this.state.searchText}
          moreToExploreCollection={moreToExploreCollection}
          moreToExplore={moreToExplore}
          onChangeSearchTextFunc={this.onChangeSearchText}
          onCreateMoreToExploreFunc={this.onCreateMoreToExplore}
          onSelectMoreToExploreFunc={this.onSelectMoreToExplore}
          onAddSelectedPlaceFunc={this.onAddSelectedPlace}
        />
      </div>
    );
  }

  renderAlertDialog(errors) {
    return (
      <div>
        <Dialog open={this.state.openAlertDialog} aria-labelledby="draggable-dialog-title">
          <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
            Alert
          </DialogTitle>
          <DialogContent>
            {errors.map((e) => {
              return <DialogContentText>{e}</DialogContentText>;
            })}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.onClickAlertDialogClose} color="primary">
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  renderConfirmDialog() {
    return (
      <div>
        <Dialog open={this.state.openDialog} aria-labelledby="draggable-dialog-title">
          <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
            Confirm
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              The data has not been saved yet. Are you sure to leave?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.onClickDialogYes} color="primary">
              Yes
            </Button>
            <Button onClick={this.onClickDialogNo} color="primary">
              No
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  renderMoreToExploreDetails(moreToExplore) {
    return (
      <div
        className={styles.center}
        onBlur={() => this.setUnsavedDataFlag(this.state.updateData)}
        key="moreToExploreDetailsKey"
      >
        <MoreToExploreDetails
          onUpdateMoreToExploreFunc={this.onUpdateMoreToExplore}
          onUpdateMoreToExploreAddressFunc={this.onUpdateMoreToExploreAddress}
          moreToExplore={moreToExplore}
        />
      </div>
    );
  }

  renderPlaces(mtePlaces) {
    const { selectedPlaces, places, selectedType } = this.state;

    let types = getCustomisedTypes();
    let mtePlacesWithOrder = [];
    if (!isEmpty(mtePlaces)) {
      mtePlaces.forEach((p, index) => {
        if (!isEmpty(p.type)) {
          let mtePlaceWithOrder = cloneDeep(p);
          mtePlaceWithOrder.order = index;
          mtePlacesWithOrder.push(mtePlaceWithOrder);
        }
      });
    }

    return (
      <div className={styles.right} key="mtePlacesKey">
        <MoreToExplorePlaces
          mtePlaces={mtePlacesWithOrder}
          types={types}
          places={places}
          selectedPlaces={selectedPlaces}
          selectedType={selectedType}
          onSwapPlacesFunc={this.onSwapPlaces}
          onSelectTypeFunc={this.onSelectType}
          onChangeTypeFunc={this.onChangeType}
          onChangePlaceFunc={this.onChangePlace}
          clearSetPlacesFunc={this.clearSetPlaces}
          onAddSelectedPlaceFunc={this.onAddSelectedPlace}
          onSaveMtePlacesFunc={this.onSaveMtePlaces}
          onDeletePlaceFunc={this.onDeletePlace}
          onDeletePlacesFunc={this.onDeletePlaces}
          onInputChangePlaceFunc={this.onInputChangePlace}
        />
      </div>
    );
  }

  render() {
    let components = [];

    const { moreToExploreCollection, moreToExplore, updateData } = cloneDeep(this.state);
    let isEnabled = !isEmpty(updateData);

    components.push(this.renderMoreToExploreList(moreToExploreCollection, moreToExplore));
    if (!isEmpty(moreToExplore)) {
      const { places = [] } = moreToExplore;
      components.push(this.renderMoreToExploreDetails(moreToExplore));
      if (!isEmpty(moreToExplore.id)) components.push(this.renderPlaces(places));
    }

    return (
      <div className={styles.root}>
        {components}
        <ACSaveBar isEnabled={isEnabled} onSaveFunc={this.onSaveMoreToExplore} />
        {this.renderConfirmDialog()}
        {this.renderAlertDialog(this.state.errors)}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getMoreToExploreCollectionFunc: (filterParams) =>
      dispatch(getMoreToExploreCollection(filterParams)),
    getPlacesFunc: (filterParams) => dispatch(getPlaces(filterParams)),

    getMoreToExploreFunc: (filterParams) => dispatch(getMoreToExplore(filterParams)),

    postMoreToExploreFunc: (moreToExplore) => dispatch(postMoreToExplore(moreToExplore)),
    patchMoreToExploreFunc: (moreToExplore) => dispatch(patchMoreToExplore(moreToExplore)),
  };
};

const mapStateToProps = (state) => {
  console.log('state', state);
  const stateMoreToExploreCollection = cloneDeep(state.moreToExploreCollection);
  const statePlaces = cloneDeep(state.places);

  const {
    isRefreshRequired = false,
    moreToExploreCollection = [],
    moreToExplore = {},
    error,
  } = stateMoreToExploreCollection;

  const { places = [] } = statePlaces;

  if (stateMoreToExploreCollection) {
    if (!isEmpty(error)) {
      console.log(error.message);
    }
  }

  if (statePlaces) {
    const statePlacesError = statePlaces.error;
    if (!isEmpty(statePlacesError)) {
      console.log(statePlacesError.message);
    }
  }

  return {
    moreToExploreCollection,
    moreToExplore,
    places,
    isRefreshRequired,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MoreToExploreCollectionPage);
